/** QuadMesh resource slice: claims the type name, re-exports its decode. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('quadmesh', ['QuadMesh']);
//# sourceMappingURL=index.js.map